/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c49ded1370dd9125e2572ecce0dec81>>
 * @codegenCommand afm workspace @atlaskit/primitives codegen-styles
 * @codegenDependency ../../../tokens/src/artifacts/tokens-raw/atlassian-light.tsx <<SignedSource::2d05e18dbb472322c67fd0bc8ec55082>>
 */
import { token } from '@atlaskit/tokens';

export const textColorMap: {
	'color.text': 'var(--ds-text)';
	'color.text.accent.lime': 'var(--ds-text-accent-lime)';
	'color.text.accent.lime.bolder': 'var(--ds-text-accent-lime-bolder)';
	'color.text.accent.red': 'var(--ds-text-accent-red)';
	'color.text.accent.red.bolder': 'var(--ds-text-accent-red-bolder)';
	'color.text.accent.orange': 'var(--ds-text-accent-orange)';
	'color.text.accent.orange.bolder': 'var(--ds-text-accent-orange-bolder)';
	'color.text.accent.yellow': 'var(--ds-text-accent-yellow)';
	'color.text.accent.yellow.bolder': 'var(--ds-text-accent-yellow-bolder)';
	'color.text.accent.green': 'var(--ds-text-accent-green)';
	'color.text.accent.green.bolder': 'var(--ds-text-accent-green-bolder)';
	'color.text.accent.teal': 'var(--ds-text-accent-teal)';
	'color.text.accent.teal.bolder': 'var(--ds-text-accent-teal-bolder)';
	'color.text.accent.blue': 'var(--ds-text-accent-blue)';
	'color.text.accent.blue.bolder': 'var(--ds-text-accent-blue-bolder)';
	'color.text.accent.purple': 'var(--ds-text-accent-purple)';
	'color.text.accent.purple.bolder': 'var(--ds-text-accent-purple-bolder)';
	'color.text.accent.magenta': 'var(--ds-text-accent-magenta)';
	'color.text.accent.magenta.bolder': 'var(--ds-text-accent-magenta-bolder)';
	'color.text.accent.gray': 'var(--ds-text-accent-gray)';
	'color.text.accent.gray.bolder': 'var(--ds-text-accent-gray-bolder)';
	'color.text.code.accent.1': 'var(--ds-text-code-accent-1)';
	'color.text.code.accent.2': 'var(--ds-text-code-accent-2)';
	'color.text.code.comments': 'var(--ds-text-code-comments)';
	'color.text.code.default': 'var(--ds-text-code-default)';
	'color.text.code.functions': 'var(--ds-text-code-functions)';
	'color.text.code.gutter': 'var(--ds-text-code-gutter)';
	'color.text.code.keywords': 'var(--ds-text-code-keywords)';
	'color.text.code.numbers': 'var(--ds-text-code-numbers)';
	'color.text.code.operators': 'var(--ds-text-code-operators)';
	'color.text.code.strings': 'var(--ds-text-code-strings)';
	'color.text.code.tags': 'var(--ds-text-code-tags)';
	'color.text.disabled': 'var(--ds-text-disabled)';
	'color.text.inverse': 'var(--ds-text-inverse)';
	'color.text.selected': 'var(--ds-text-selected)';
	'color.text.brand': 'var(--ds-text-brand)';
	'color.text.danger': 'var(--ds-text-danger)';
	'color.text.danger.bolder': 'var(--ds-text-danger-bolder)';
	'color.text.warning': 'var(--ds-text-warning)';
	'color.text.warning.inverse': 'var(--ds-text-warning-inverse)';
	'color.text.warning.bolder': 'var(--ds-text-warning-bolder)';
	'color.text.success': 'var(--ds-text-success)';
	'color.text.success.bolder': 'var(--ds-text-success-bolder)';
	'color.text.discovery': 'var(--ds-text-discovery)';
	'color.text.discovery.bolder': 'var(--ds-text-discovery-bolder)';
	'color.text.information': 'var(--ds-text-information)';
	'color.text.information.bolder': 'var(--ds-text-information-bolder)';
	'color.text.subtlest': 'var(--ds-text-subtlest)';
	'color.text.subtle': 'var(--ds-text-subtle)';
	'color.link': 'var(--ds-link)';
	'color.link.pressed': 'var(--ds-link-pressed)';
	'color.link.visited': 'var(--ds-link-visited)';
	'color.link.visited.pressed': 'var(--ds-link-visited-pressed)';
} = {
	'color.text': token('color.text', '#292A2E'),
	'color.text.accent.lime': token('color.text.accent.lime', '#4C6B1F'),
	'color.text.accent.lime.bolder': token('color.text.accent.lime.bolder', '#37471F'),
	'color.text.accent.red': token('color.text.accent.red', '#AE2E24'),
	'color.text.accent.red.bolder': token('color.text.accent.red.bolder', '#5D1F1A'),
	'color.text.accent.orange': token('color.text.accent.orange', '#9E4C00'),
	'color.text.accent.orange.bolder': token('color.text.accent.orange.bolder', '#693200'),
	'color.text.accent.yellow': token('color.text.accent.yellow', '#7F5F01'),
	'color.text.accent.yellow.bolder': token('color.text.accent.yellow.bolder', '#533F04'),
	'color.text.accent.green': token('color.text.accent.green', '#216E4E'),
	'color.text.accent.green.bolder': token('color.text.accent.green.bolder', '#164B35'),
	'color.text.accent.teal': token('color.text.accent.teal', '#206A83'),
	'color.text.accent.teal.bolder': token('color.text.accent.teal.bolder', '#164555'),
	'color.text.accent.blue': token('color.text.accent.blue', '#1558BC'),
	'color.text.accent.blue.bolder': token('color.text.accent.blue.bolder', '#123263'),
	'color.text.accent.purple': token('color.text.accent.purple', '#803FA5'),
	'color.text.accent.purple.bolder': token('color.text.accent.purple.bolder', '#48245D'),
	'color.text.accent.magenta': token('color.text.accent.magenta', '#943D73'),
	'color.text.accent.magenta.bolder': token('color.text.accent.magenta.bolder', '#50253F'),
	'color.text.accent.gray': token('color.text.accent.gray', '#505258'),
	'color.text.accent.gray.bolder': token('color.text.accent.gray.bolder', '#1E1F21'),
	'color.text.code.accent.1': token('color.text.code.accent.1', '#943D73'),
	'color.text.code.accent.2': token('color.text.code.accent.2', '#1558BC'),
	'color.text.code.comments': token('color.text.code.comments', '#505258'),
	'color.text.code.default': token('color.text.code.default', '#505258'),
	'color.text.code.functions': token('color.text.code.functions', '#216E4E'),
	'color.text.code.gutter': token('color.text.code.gutter', '#6B6E76'),
	'color.text.code.keywords': token('color.text.code.keywords', '#AE2E24'),
	'color.text.code.numbers': token('color.text.code.numbers', '#7F5F01'),
	'color.text.code.operators': token('color.text.code.operators', '#292A2E'),
	'color.text.code.strings': token('color.text.code.strings', '#4C6B1F'),
	'color.text.code.tags': token('color.text.code.tags', '#9E4C00'),
	'color.text.disabled': token('color.text.disabled', '#080F214A'),
	'color.text.inverse': token('color.text.inverse', '#FFFFFF'),
	'color.text.selected': token('color.text.selected', '#1868DB'),
	'color.text.brand': token('color.text.brand', '#1868DB'),
	'color.text.danger': token('color.text.danger', '#AE2E24'),
	'color.text.danger.bolder': token('color.text.danger.bolder', '#5D1F1A'),
	'color.text.warning': token('color.text.warning', '#9E4C00'),
	'color.text.warning.inverse': token('color.text.warning.inverse', '#292A2E'),
	'color.text.warning.bolder': token('color.text.warning.bolder', '#693200'),
	'color.text.success': token('color.text.success', '#4C6B1F'),
	'color.text.success.bolder': token('color.text.success.bolder', '#37471F'),
	'color.text.discovery': token('color.text.discovery', '#803FA5'),
	'color.text.discovery.bolder': token('color.text.discovery.bolder', '#48245D'),
	'color.text.information': token('color.text.information', '#1558BC'),
	'color.text.information.bolder': token('color.text.information.bolder', '#123263'),
	'color.text.subtlest': token('color.text.subtlest', '#6B6E76'),
	'color.text.subtle': token('color.text.subtle', '#505258'),
	'color.link': token('color.link', '#1868DB'),
	'color.link.pressed': token('color.link.pressed', '#1558BC'),
	'color.link.visited': token('color.link.visited', '#803FA5'),
	'color.link.visited.pressed': token('color.link.visited.pressed', '#48245D'),
} as const;

export type TextColor = keyof typeof textColorMap;
